<div matDialogTitle>
  <div class="flex flex-row justify-space-between -mt-4">
    <h2>Book Pickup</h2>
    <app-courier-logo [courierModule]="courierModule$ | async" class="ml-auto"></app-courier-logo>
  </div>
</div>
<mat-dialog-content>
  @if (busy$ | async) {
    <div class="spinner-container">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
  }

  <div>
    @for (message of messages$ | async; track message) {
      <app-server-message [message]="message"></app-server-message>
    }
  </div>

  @if (!(busy$ | async)) {
    <div [formGroup]="pickupForm" class="flex flex-col md:flex-row gap-2">
      <div class="flex flex-col md:w-1/2 grow">
        <mat-form-field>
          <mat-label i18n>Pickup Date</mat-label>
          <input matInput formControlName="date" (dateChange)="changeDate()" [matDatepickerFilter]="dateFilter"
            [matDatepicker]="pickupDatePicker">
          <mat-datepicker-toggle matSuffix [for]="pickupDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #pickupDatePicker></mat-datepicker>
        </mat-form-field>
        <div class="flex flex-row gap-2">
          <mat-form-field>
            <mat-label i18n>Ready Time</mat-label>
            <mat-select formControlName="readyTime" (selectionChange)="changeReadyTime()" [disabled]="(pickupReadyTimes$ | async).length == 0">
              @for (time of pickupReadyTimes$ | async; track time) {
                <mat-option [value]="time">
                  {{ time }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field>
            <mat-label i18n>Close Time</mat-label>
            <mat-select formControlName="closeTime" (selectionChange)="changeCloseTime()" [disabled]="(pickupCloseTimes$ | async).length == 0">
              @for (time of pickupCloseTimes$ | async; track time) {
                <mat-option [value]="time">
                  {{ time }}
                </mat-option>
              }
            </mat-select>
            @if (pickupForm.hasError('minimumWindow')) {
              <mat-error i18n>
                        Close Time must be at least {{ minimumWindowMinutes }} minutes after Ready Time
                    </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
      @if ((courierPickupParameters$ | async).length > 0) {
        <div [formGroup]="parametersGroup" class="flex flex-col md:w-1/2 grow"
          >
          @for (parameter of courierPickupParameters$ | async; track parameter) {
            <mat-form-field>
              <mat-label>{{ parameter.label }}</mat-label>
              @if (parameter.choices.length === 0) {
                <input matInput [formControlName]="parameter.code"
                  (change)="changeParameter(parameter)">
              }
              @if (parameter.choices.length > 0) {
                <mat-select [formControlName]="parameter.code"
                  (selectionChange)="changeParameter(parameter)">
                  @for (choice of parameter.choices; track choice) {
                    <mat-option [value]="choice.value">
                      {{ choice.label }}
                    </mat-option>
                  }
                </mat-select>
              }
            </mat-form-field>
          }
        </div>
      }
    </div>
  }

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()" color="primary" i18n>
        CLOSE
    </button>
  <button mat-button (click)="submit()" color="primary" [disabled]="(invalid$ | async) || (busy$ | async)" i18n>
        SUBMIT
    </button>
</mat-dialog-actions>
